import React from 'react';

// container the timeline is in, handles padding / spacing around timeline and
// blurs out background if loading is taking place
const TimelineContainer = ({ loading, children, onClick }) => {

    return (
        <div style={{ opacity: loading ? 0.2 : 1.0, overscrollBehaviorY: "contain" }}
            id='timeLineContainer'
            onClick={onClick}
        >
            {children}
        </div>
    );
};

export default TimelineContainer;
